import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import Layout from '../components/Layout';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const TINT: Record<string, string> = {
  orange: 'border-mfb-orange/30 bg-mfb-orange/5 text-mfb-orange',
  blue: 'border-mfb-blue/30 bg-mfb-blue/5 text-mfb-blue',
  slate: 'border-slate-200 bg-slate-50 text-slate-600',
};

export const AdminDashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const { accessToken, isAuthenticated } = useAuthStore();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated || !accessToken) { navigate('/login'); return; }
    const load = () => fetch(`${API_BASE_URL}/api/admin/dashboard`, { headers: { Authorization: `Bearer ${accessToken}` }, cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null)).then(setData).finally(() => setLoading(false));
    load();
    // ververs zodra het tabblad weer focus krijgt (bv. na muteren elders)
    const onFocus = () => { if (document.visibilityState === 'visible') load(); };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onFocus);
    return () => { window.removeEventListener('focus', onFocus); document.removeEventListener('visibilitychange', onFocus); };
  }, [isAuthenticated, accessToken, navigate]);

  const groepen: any[] = data?.groepen || [];

  return (
    <Layout>
      <div className="mb-6">
        <h1 className="font-display text-2xl font-semibold text-mfb-blue">Dashboard</h1>
        <p className="text-sm text-slate-500">
          Openstaande acties, in dezelfde indeling als het menu.{' '}
          {data ? <span className="font-medium text-slate-700">{data.totaal_open} openstaand</span> : null}
        </p>
      </div>

      {loading ? (
        <div className="text-center py-12 text-slate-500">Laden...</div>
      ) : (
        <div className="space-y-8">
          {groepen.map((g) => (
            <div key={g.key}>
              <h2 className="text-[11px] font-semibold uppercase tracking-widest text-slate-400 mb-3">{g.label}</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {g.acties.map((a: any) => (
                  <button key={a.key} onClick={() => navigate(a.pad)}
                    className={`text-left rounded-2xl border p-5 transition hover:shadow-lg hover:-translate-y-0.5 ${a.count > 0 ? (TINT[a.tint] || TINT.blue) : 'border-slate-200 bg-white text-slate-400'}`}>
                    <div className="flex items-center justify-between">
                      <span className="text-3xl font-display font-bold tabular-nums">{a.count}</span>
                      {a.count > 0 && a.tint !== 'slate' && <span className="text-xs font-semibold uppercase tracking-wide">Actie</span>}
                    </div>
                    <div className="mt-2 text-sm font-medium text-slate-700">{a.label}</div>
                    <div className="mt-3 text-xs font-semibold text-mfb-orange">Openen →</div>
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      {data && data.totaal_open === 0 && !loading && (
        <div className="mt-6 rounded-2xl border border-emerald-200 bg-emerald-50 p-5 text-sm text-emerald-800">
          Geen openstaande acties — alles is bijgewerkt. 🎉
        </div>
      )}
    </Layout>
  );
};

export default AdminDashboardPage;
